import {NgModule} from '@angular/core';
import {ContextService} from "./context.service";
import {ConnectedUserService} from "./connected-user.service";
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {RouterModule} from "@angular/router";

@NgModule({
    declarations: [],
    imports: [RouterModule],
    providers: [
        ContextService,
        ConnectedUserService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class ContextModule {
}
